import { PaginatedResponse } from './index';

export type CampaignState = 'draft' | 'active' | 'paused' | 'archived';

export const CAMPAIGN_STATES: CampaignState[] = ['draft', 'active', 'paused', 'archived'];

export const CAMPAIGN_STATE_LABEL: Record<CampaignState, string> = {
  draft: 'Bozza',
  active: 'Attiva',
  paused: 'In pausa',
  archived: 'Archiviata',
};

export type DeliveryFilterState =
  | 'all'
  | 'sent'
  | 'opened'
  | 'clicked'
  | 'unsubscribed'
  | 'bounced';

export const DELIVERY_FILTER_STATES: DeliveryFilterState[] = [
  'all',
  'sent',
  'opened',
  'clicked',
  'unsubscribed',
  'bounced',
];

export const DELIVERY_FILTER_STATE_LABEL: Record<DeliveryFilterState, string> = {
  all: 'Tutti',
  sent: 'Inviati',
  opened: 'Aperti',
  clicked: 'Click',
  unsubscribed: 'Unsubscribed',
  bounced: 'Bounce',
};

export interface LeadCampaignBase {
  name: string;
  description?: string | null;
  segment_id: string;
  from_email: string;
  from_name: string;
  reply_to?: string | null;
}

export interface LeadCampaignCreate extends LeadCampaignBase {}

export interface LeadCampaignUpdate {
  name?: string;
  description?: string;
  segment_id?: string;
  from_email?: string;
  from_name?: string;
  reply_to?: string | null;
}

export interface LeadCampaignResponse {
  id: string;
  tenant_id: string;
  name: string;
  description?: string | null;
  segment_id: string;
  state: CampaignState;
  is_active: boolean;
  from_email: string;
  from_name: string;
  reply_to?: string | null;
  started_at?: string | null;
  archived_at?: string | null;
  created_at: string;
  updated_at?: string | null;
  created_by?: string | null;
  updated_by?: string | null;
  is_deleted: boolean;
}

export interface LeadCampaignListResponse extends PaginatedResponse<LeadCampaignResponse> {}

export interface LeadCampaignStepBase {
  ordine: number;
  delay_days: number;
  subject: string;
  body_markdown: string;
}

export interface LeadCampaignStepCreate extends LeadCampaignStepBase {}

export interface LeadCampaignStepUpdate {
  ordine?: number;
  delay_days?: number;
  subject?: string;
  body_markdown?: string;
}

export interface LeadCampaignStepResponse {
  id: string;
  tenant_id: string;
  campaign_id: string;
  ordine: number;
  delay_days: number;
  subject: string;
  body_markdown: string;
  body_html_rendered?: string | null;
  created_at: string;
  updated_at?: string | null;
  is_deleted: boolean;
}

export interface LeadCampaignMetrics {
  campaign_id: string;
  sent: number;
  opened: number;
  clicked: number;
  unsubscribed: number;
  open_rate: number;
  click_rate: number;
  unsubscribe_rate: number;
}

export interface LeadCampaignDeliveryResponse {
  id: string;
  tenant_id: string;
  lead_id: string;
  campaign_id: string;
  step_id: string;
  sent_at: string;
  opened_at?: string | null;
  clicked_at?: string | null;
  unsubscribed_at?: string | null;
  bounce_reason?: string | null;
}

export interface LeadCampaignDeliveryListResponse
  extends PaginatedResponse<LeadCampaignDeliveryResponse> {}

export interface PreviewStepResponse {
  step_id: string;
  lead_id: string;
  subject: string;
  html: string;
}
